import { useState } from 'react';
import { WORK_GUIDANCE_MOTIFS, WORK_GUIDANCE_MOTIF_LABELS, type WorkGuidanceMotif } from '@/lib/work-guidance';

const ITEM_CLASS = 'flex w-full items-center px-3 py-2 text-left text-sm text-domino-ink hover:bg-domino-muted disabled:opacity-50';

/** J6: set work aside with a motive; « Autre » asks for one line. */
export const GuidanceMotifItems = ({ disabled = false, onPick }: {
  disabled?: boolean;
  onPick: (motif: WorkGuidanceMotif, note: string | null) => void;
}) => {
  const [writing, setWriting] = useState(false);
  const [note, setNote] = useState('');
  return (
    <div className="border-b border-domino-cardBorder py-1">
      {WORK_GUIDANCE_MOTIFS.filter((motif) => motif !== 'other').map((motif) => (
        <button key={motif} type="button" disabled={disabled} onClick={() => onPick(motif, null)} className={ITEM_CLASS}>
          {WORK_GUIDANCE_MOTIF_LABELS[motif]}
        </button>
      ))}
      {writing ? (
        <form
          className="flex items-center gap-2 px-3 py-1.5"
          onSubmit={(event) => {
            event.preventDefault();
            if (note.trim()) onPick('other', note.trim());
          }}
        >
          <input
            autoFocus
            aria-label="Motif"
            maxLength={500}
            value={note}
            onChange={(event) => setNote(event.target.value)}
            className="min-w-0 flex-1 rounded border border-domino-cardBorder px-2 py-1 text-xs"
          />
          <button type="submit" disabled={disabled || !note.trim()} className="text-sm text-domino-aubergine disabled:opacity-40">OK</button>
        </form>
      ) : (
        <button type="button" disabled={disabled} onClick={() => setWriting(true)} className={ITEM_CLASS}>Autre…</button>
      )}
    </div>
  );
};
